module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-21.bfecf40c.png";